<template>
  <div
    class="page-header header-filter"
    filter-color="orange"
  >
    <div
      class="page-header-image"
      style="background-image: url('img/background/FCX-bg.jpg')"
    />
    <div class="content-center">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <card
            type="login"
            plain
          >
            <div
              slot="header"
              class="logo-container d-none d-md-block"
            >
              <img
                v-lazy="'img/logo/FCX-Logo-signet.png'"
                alt=""
              >
            </div>

            <form @submit.prevent="login">
              <fg-input
                v-model="form.email"
                :required="true"
                minlength="5"
                maxlength="255"
                class="no-border input-lg"
                addon-left-icon="now-ui-icons ui-1_email-85"
                placeholder="Email..."
              />

              <fg-input
                v-model="form.password"
                :required="true"
                minlength="5"
                maxlength="255"
                type="password"
                class="no-border input-lg"
                addon-left-icon="now-ui-icons text_caps-small"
                placeholder="Password..."
              />
              <div class="card-footer text-center">
                <n-button
                  native-type="submit"
                  class="btn btn-primary btn-round btn-lg btn-block"
                >
                  Login
                </n-button>
              </div>
            </form>
            <template slot="raw-content">
              <div class="pull-left">
                <h6>
                  <router-link
                    class="link footer-link"
                    to="/signup"
                  >
                    <i class="fa fa-mobile" /> Register
                  </router-link>
                  <router-link
                    class="link footer-link"
                    to="/forgotpassword"
                  >
                    <i class="fa fa-unlock"></i> Forgot password
                  </router-link>
                </h6>
              </div>
              <div class="pull-right">
                <h6>
                  <router-link
                    class="link footer-link"
                    to="/contact"
                  >
                    <i class="fa fa-question-circle" /> Need Help?
                  </router-link>

                </h6>
              </div>
            </template>

          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Button, FormGroupInput } from '@/components';
  export default {
    name: 'LoginPage',
    bodyClass: 'login-page',
    components: {
      Card,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        form: {
          email: "",
          password: ""
        }
      }
    },
    methods: {
      login: function() {
        this.LoadingX = true;
        this.$store
          .dispatch("LOGIN", this.form)
          .then(res => {
            this.$router.push('/');
          })
          .catch(error => {
            //this.$errorHandler.defaultLLocalApiErrorHandler(this, error, "expire catalog item");
            Logger.debug("error", error);
            this.$notify({
              title: "Login failed",
              message:'Please enter a correct email/password.',
              type: "danger",
              timeout: 3000,
              horizontalAlign: "right",
              verticalAlign: "top",
              icon: 'nc-icon nc-app',
            });
          })
          .finally(() => {
            // using "finally" so even if there are errors, it stops "loading"
            //Logger.trace("disableItemGeneric finally");
            this.LoadingX = false;
          });
      }
    }
  }
</script>
<style>
</style>
